import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import MarketLayoutDescriptors from './_market-layout-descriptors.js'

export default {
  name: 'SelectionHeaders',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '18px',
        },
      },
    },
    label: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexBasis: '0%',
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
